import React, { useState } from "react";
import { FaClipboardList } from "react-icons/fa";
import PageHeader from "../../../core/common/header/PageHeader";
import StudentClassTests from "./StudentClassTests";
import StudentTakeClassTest from "./StudentTakeClassTest";
import StudentClassTestResult from "./StudentClassTestResult";

type View = "list" | "take" | "result";

const StudentClassTestPage: React.FC = () => {
  const [view, setView] = useState<View>("list");
  const [activeAssignmentId, setActiveAssignmentId] = useState<number | null>(null);
  const [activeAttemptId, setActiveAttemptId] = useState<number | null>(null);

  const handleStart = (assignmentId: number) => {
    setActiveAssignmentId(assignmentId);
    setView("take");
  };

  const handleViewResult = (attemptId: number) => {
    setActiveAttemptId(attemptId);
    setView("result");
  };

  if (view === "take" && activeAssignmentId) {
    return (
      <StudentTakeClassTest
        assignmentId={activeAssignmentId}
        onBack={() => setView("list")}
        onSubmitted={() => setView("list")}
      />
    );
  }

  if (view === "result" && activeAttemptId) {
    return (
      <StudentClassTestResult
        attemptId={activeAttemptId}
        onBack={() => setView("list")}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        icon={<FaClipboardList />}
        title="My Class Tests"
        breadcrumb={[
          { label: "Home", to: "/" },
          { label: "Dashboard", to: "/student/student-dashboard" },
          { label: "Class Tests" },
        ]}
      />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <StudentClassTests onStart={handleStart} onViewResult={handleViewResult} />
      </main>
    </div>
  );
};

export default StudentClassTestPage;
